var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvySword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.656 16.156C42.71 16.533 31.24 29.793 24.5 44.813 6.05 85.91 32.88 81.803 71.156 90.374 79.272 66.585 86.96 48.042 94.72 31.53A262.78 262.78 0 0 0 71 19.126c-4.708-2.162-9.158-3.074-13.344-2.97zm52.907 25.5c-7.026 15.13-13.945 32.076-21.344 53.688 10.168 3.41 20.723 8.157 31.155 15.094 11.68-12.212 23.456-21.498 35.28-29.063-13.287-14.6-28.152-27.967-45.093-39.72zm57.28 53.97c-11.064 6.804-21.837 15.1-32.718 26.343 11.416 10.345 22.372 23.944 32.125 42.124 7.94-13.026 16.59-23.73 25.625-33.125-7.722-12.28-15.997-24.11-25.03-35.345zm104.876 6.655c-21.823 9.456-42.608 20.63-59.908 35.126-.123.117-.25.227-.375.344-13.47 12.74-25.593 27.446-36.28 48.72a121.5 121.5 0 0 0-5.72 18.03c21.49 66.477 64.75 126.913 119.5 172.094 33.212 37.003 79.484 67.087 129.47 89.03C300.828 433.35 196.2 335.897 155.124 217.563c-13.287 6.835-27.93 11.178-42.03 11.625 77.753 185.39 256.893 319.184 382.28 238.657-161.46-55.25-192.335-204.99-257.28-326.344 12.505-8.307 26.713-15.444 42.06-22.094l-7.436-17.125z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvySword);
export default __webpack_public_path__ + "static/media/curvy_sword.70b22f8f409535099e9897f86b1038fa.svg";
export { ForwardRef as ReactComponent };